import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ButtonCta1 from "../button/ButtonCta1";
import { BASE_URL, toastConfig } from "../../constants/constant";
import { Service } from "../../services/service";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setAddButtonDisabled,
  setButtonAction,
  setHeader,
  setUpdateButtonDisabled,
} from "../../reduxSlices/headerSlice";
import CommonDialog from "../dialog/CommonDialog";
import ContentLoader from "../loader/ContentLoader";
import { v4 as uuidv4 } from "uuid";
import { CustomTextField, validateEmail } from "../../helpers/helper";
import { getAllVfUsers } from "../../reduxSlices/vfuserSlice";

const service = new Service();

const CreateVfUser = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userId } = useParams();
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  const [vfUser, setVfUser] = useState({
    userId: "",
    emailId: "",
    familyName: "",
    givenName: "",
  });

  const buttonAction = useSelector((state) => state?.header?.buttonAction);
  const allVfUsers = useSelector((state) => state.vfuser.allVfUsers);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const areInputsFilled = () => {
    return (
      vfUser?.emailId?.trim() !== "" && vfUser?.givenName?.trim() !== ""
      // isValid
    );
  };
  const inputFilled = areInputsFilled();

  const getVfUserData = async () => {
    const obj = {
      searchText: "",
    };
    await dispatch(getAllVfUsers(obj));
  };

  useEffect(() => {
    if (!userId) return;
    getVfUserData();
  }, [userId]);

  useEffect(() => {
    if (!allVfUsers && !userId) return;
    if (userId) {
      const filterVfUser = allVfUsers.filter((user) => user.userId === userId);
      console.log("filterVfUser", filterVfUser);
      filterVfUser?.map((user) => setVfUser({ ...user }));
    }
  }, [userId, allVfUsers]);

  useEffect(() => {
    console.log("vfUser>>>>", vfUser);
  }, [vfUser]);

  useEffect(() => {
    console.log("inputFilled>>>>", inputFilled);
    dispatch(setAddButtonDisabled(inputFilled));
  }, [inputFilled]);

  useEffect(() => {
    dispatch(
      setHeader({
        page: !userId ? "add-vfuser" : "edit-vfuser",
        title: !userId ? "Add User" : "Update User",
        subTitle: !userId
          ? "Please fill all the mandatory details to add new Visualise user"
          : "Please update the details if there are any discrepancies",
      })
    );
  }, []);

  useEffect(() => {
    const isEmailValid = validateEmail(vfUser.emailId);
    if (vfUser.emailId) {
      setIsValid(isEmailValid);
    }
  }, [vfUser.emailId]);

  useEffect(() => {
    if (
      (buttonAction.page === "add-vfuser" && buttonAction.action === "add") ||
      (buttonAction.page.includes("edit-vfuser") &&
        buttonAction.action === "update")
    ) {
      console.log("buttonAction called");
      handleSubmit();
    }
    if (
      (buttonAction.page === "add-vfuser" &&
        buttonAction.action === "cancel") ||
      (buttonAction.page.includes("edit-vfuser") &&
        buttonAction.action === "cancel")
    ) {
      console.log("buttonAction called");
      handleClickOpen();
    }
    dispatch(
      setButtonAction({
        page: "",
        action: "",
      })
    );
  }, [buttonAction.page, buttonAction.action]);

  useEffect(() => {
    const fetchOrganization = async () => {
      let url = `/api/Organization/OrganizationMaster`;
      const user_token = localStorage.getItem("bb_access_token");
      try {
        let data = await service.newGetApi(url, {}, user_token);
        let resp = data.data;
        console.log("resp", resp);
        setOrganizationOptions(resp);
      } catch (err) {
        console.log(err);
      }
    };
    fetchOrganization();
  }, []);

  const handleOrganizationChange = (e) => {
    const { name, value } = e.target;
    setVfUser({ ...vfUser, [name]: value });
  };

  const handleInputFocus = () => {
    if (!userId) return;
    console.log("User clicked on the input text.");
    dispatch(setUpdateButtonDisabled(true));
  };

  // const handleAutoCompleteChange = (name, value) => {
  //   setVfUser((prevState) => ({ ...prevState, [name]: value }));
  // };

  const handleGoBack = () => {
    navigate(-1);
    setOpen(false);
  };

  const handleSubmit = () => {
    if (!userId) {
      createVfUser();
    } else {
      updateVfUser();
    }
  };

  const createVfUser = async () => {
    if (isValid) {
      setIsButtonClicked(false);
      setLoader(true);
      let url = `/api/User/AddVFAdmin`;
      const user_token = localStorage.getItem("bb_access_token");
      const vfUserData = prepareData();
      const formData = JSON.stringify(vfUserData);
      try {
        let data = await service.newPostApi(url, formData, user_token);
        let resp = data.data;
        console.log("resp", resp);
        if (resp?.data && resp?.success) {
          toast.success("New Visualise user has been added", {
            ...toastConfig,
            style: {
              backgroundColor: "#4a67ad",
            },
          });
          navigate("/vfusers");
          setLoader(false);
        } else {
          setLoader(false);
          toast.warning(resp?.errorMessage, toastConfig);
        }
      } catch (err) {
        console.log(err);
        setLoader(false);
        toast.error(err?.message, toastConfig);
      }
    } else {
      setIsButtonClicked(true);
    }
  };

  const updateVfUser = async () => {
    if (isValid) {
      setIsButtonClicked(false);
      setLoader(true);
      let url = `/api/User/UpdateVFAdmin`;
      const user_token = localStorage.getItem("bb_access_token");
      const vfUserData = prepareData();
      const formData = JSON.stringify(vfUserData);
      try {
        let data = await service.newPutApi(url, formData, user_token);
        let resp = data.data;
        let emailId = resp.emailId;
        console.log("resp", resp, emailId);
        if (resp?.data && resp?.success) {
          toast.success("User details has been updated", {
            ...toastConfig,
            style: {
              backgroundColor: "#4a67ad",
            },
          });
          setVfUser({ userId: "", emailId: "", familyName: "", givenName: "" });
          navigate("/vfusers");
          setLoader(false);
        } else {
          setLoader(false);
          toast.warning(resp?.errorMessage, toastConfig);
        }
        getVfUserData();
      } catch (err) {
        console.log(err);
        setLoader(false);
        toast.error(err.message, toastConfig);
      }
    } else {
      setIsButtonClicked(true);
    }
  };

  const prepareData = () => {
    return {
      userId: !userId ? uuidv4() : vfUser?.userId,
      emailId: vfUser?.emailId,
      familyName: vfUser?.familyName,
      givenName: vfUser?.givenName,
    };
  };

  if (loader) return <ContentLoader />;

  return (
    <>
      <div
        style={{
          borderRadius: "12px",
          backgroundColor: "#fff",
          padding: "32px 32px 10px 0",
          //   height: "calc(100vh - 340px)",
          overflowY: "auto",
        }}
      >
        <Box
          component="form"
          sx={{
            "& > :not(style)": { marginBottom: "20px", width: "520px" },
          }}
          noValidate
          autoComplete="off"
        >
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <label style={labelStyle}>
                First Name<sup style={requiredAr}>*</sup>
              </label>
              <CustomTextField
                placeholder="Enter the first name..."
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="givenName"
                sx={{ width: "240px" }}
                value={vfUser?.givenName}
                onChange={handleOrganizationChange}
                onFocus={handleInputFocus}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "40px",
              }}
            >
              <label style={labelStyle}>Last Name (Optional)</label>
              <CustomTextField
                placeholder="Enter the last name..."
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="familyName"
                sx={{ width: "240px" }}
                value={vfUser?.familyName}
                onChange={handleOrganizationChange}
                onFocus={handleInputFocus}
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              Email<sup style={requiredAr}>*</sup>
            </label>
            <CustomTextField
              placeholder="Enter the email..."
              id="outlined-basic"
              variant="outlined"
              type="text"
              name="emailId"
              sx={{ width: "520px" }}
              value={vfUser?.emailId}
              onChange={handleOrganizationChange}
              onFocus={handleInputFocus}
            />
            {vfUser.emailId && !isValid && isButtonClicked && (
              <Typography
                sx={{
                  color: "red",
                  fontSize: "14px",
                  fontWeight: 500,
                  fontFamily: "Montserrat",
                }}
              >
                Email is not valid.
              </Typography>
            )}
          </Box>
        </Box>
      </div>

      <CommonDialog
        open={open}
        setOpen={setOpen}
        handleCancel={handleClose}
        handleDone={handleGoBack}
        title="All changes will be lost"
        subTitle="Are you sure you want to discard changes?"
        leftButtonText="Cancel"
        rightButtonText="Discard"
      />
    </>
  );
};

export default CreateVfUser;

const labelStyle = {
  fontSize: "14px",
  letterSpacing: "-0.02em",
  fontWeight: 600,
  fontFamily: "Montserrat",
  color: "#282828",
  textAlign: "left",
  marginBottom: "8px",
};

const requiredAr = {
  color: "#CF4500",
  fontSize: "13px",
  verticalAlign: "baseline",
};
